import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { canSearch } from "../data/viewer.ts";
import { SearchPage } from "../search/search-page.tsx";
import { retainPropertyFilter, searchSearch } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !canSearch(viewer) ? <NoAccessPage /> : <SearchPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/search")({
  staticData: { hasPropertyContext: true },
  validateSearch: searchSearch,
  search: retainPropertyFilter(),
  component: Page,
});
